import { Button } from "@/components/button";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";
import { FC, useEffect } from "react";
import styled from "@emotion/styled";

interface Notification {
  id: string;
  title: string;
  content: string;
  notification_kind: string;
}

export const NotificationsPage: FC = () => {
  const result = useQuery({
    queryKey: ["my-notifications"],
    queryFn: () =>
      api.post("/internal/v1/me/staff/member-notifications/search", {
        body: { limit: 100 },
      }),
  });

  const notifications: Notification[] = result.data?.data?.results ?? [];

  useEffect(() => {
    if (notifications.length) {
      api.post("/internal/v1/me/staff/member-notifications/mark-read", {
        body: { notification_ids: notifications.map(n => n.id) },
      });
    }
  }, [notifications]);

  const handleDismiss = async (id: string) => {
    await api.post("/internal/v1/me/staff/member-notifications/dismiss", {
      body: { notification_ids: [id] },
    });
    result.refetch();
  };

  return (
    <Container>
      <h1>Notifications</h1>
      <ul>
        {notifications.map(n => (
          <li key={n.id}>
            <strong>{n.title}</strong> - {n.content}
            <Button size="1" onClick={() => handleDismiss(n.id)}>
              Dismiss
            </Button>
          </li>
        ))}
      </ul>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
`;
